export const USER_ROLES = ['owner', 'tenant', 'support', 'admin'] as const
export type AppRole = (typeof USER_ROLES)[number]

export const IDENTITY_VERIFICATION_STATUSES = [
  'profile_incomplete',
  'identity_pending',
  'identity_in_review',
  'identity_correction_requested',
  'identity_approved',
  'identity_rejected',
] as const
export type IdentityVerificationStatus = (typeof IDENTITY_VERIFICATION_STATUSES)[number]

export const LISTING_STATUSES = [
  'draft',
  'property_validation_pending',
  'property_docs_in_review',
  'property_correction_requested',
  'ready_to_publish',
  'active',
  'paused',
  'closed',
  'rejected',
] as const
export type ListingManagerStatus = (typeof LISTING_STATUSES)[number]

export const APPLICATION_STATUSES = [
  'started',
  'identity_required',
  'documents_requested',
  'documents_in_review',
  'correction_requested',
  'submitted_to_owner',
  'owner_review',
  'approved',
  'rejected',
  'withdrawn',
] as const
export type ApplicationPipelineStatus = (typeof APPLICATION_STATUSES)[number]

export const VISIT_SLOT_STATUSES = ['open', 'blocked', 'cancelled'] as const
export type VisitSlotStatus = (typeof VISIT_SLOT_STATUSES)[number]

export const VISIT_REQUEST_STATUSES = [
  'pending',
  'confirmed',
  'declined',
  'cancelled',
  'completed',
  'no_show',
] as const
export type VisitRequestStatus = (typeof VISIT_REQUEST_STATUSES)[number]

export const LISTING_PUBLIC_STATUSES: readonly ListingManagerStatus[] = ['active']
export const APPLICATION_TERMINAL_STATUSES: readonly ApplicationPipelineStatus[] = [
  'approved',
  'rejected',
  'withdrawn',
]

export function isIdentityVerificationStatus(value: string): value is IdentityVerificationStatus {
  return IDENTITY_VERIFICATION_STATUSES.includes(value as IdentityVerificationStatus)
}

export function isListingManagerStatus(value: string): value is ListingManagerStatus {
  return LISTING_STATUSES.includes(value as ListingManagerStatus)
}

export function isApplicationPipelineStatus(value: string): value is ApplicationPipelineStatus {
  return APPLICATION_STATUSES.includes(value as ApplicationPipelineStatus)
}

